import { PropsWithChildren } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AnalyticsProvider } from '@/analytics';
import { ServicesProvider } from '@/providers/services-provider';
import { TabSyncProvider } from '@/providers/tab-sync-provider';

import { ENVIRONMENT } from '@/constants';
import { auth0Scope } from '@flintmint/web-shared/hooks/use-auth-user';
import { getAuth0RedirectUri } from '@/utils/get-auth0-redirect-uri';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export const AppProvider = (props: PropsWithChildren) => {
  const redirectUri = getAuth0RedirectUri();

  return (
    <AnalyticsProvider>
      <Auth0Provider
        domain={ENVIRONMENT.VITE_APP_AUTH0_DOMAIN}
        clientId={ENVIRONMENT.VITE_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          scope: auth0Scope,
          prompt: 'select_account',
          audience: ENVIRONMENT.VITE_APP_AUTH0_AUDIENCE,
          redirect_uri: redirectUri,
        }}
        useRefreshTokens
        cacheLocation="localstorage"
      >
        <QueryClientProvider client={queryClient}>
          <ServicesProvider>
            <TabSyncProvider>{props.children}</TabSyncProvider>
          </ServicesProvider>
        </QueryClientProvider>
      </Auth0Provider>
    </AnalyticsProvider>
  );
};
